import { batch } from 'solid-js';
import { createStore, produce } from 'solid-js/store';
import getBootState from '#src/client/common/dom/getBootState.js';

export default function StandardStore(director) {
    const bootState = getBootState();

    const [store, setStore] = createStore(director.transformServerData(director.genDefaultData(), bootState));

    // Do initial validation.
    setStore(produce((state) => {
        director.validation(state);
    }));

    const updateStore = (dataList) => {
        batch(() => {
            setStore.apply(null, dataList);

            // Apply validation after updating state.
            setStore(produce((state) => {
                director.validation(state);
            }));
        });
    };

    return [store, updateStore];
}
